var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 13.1945L2.81262 11.3976C2.54442 11.2859 2.375 11.0575 2.375 10.8076V3.70637C2.375 3.21594 2.99433 2.89697 3.52071 3.1163L7.125 4.61808M7.125 13.1945L11.875 11.2153M7.125 13.1945V4.61808M11.875 11.2153L15.4793 12.7171C16.0057 12.9364 16.625 12.6174 16.625 12.127V5.02581C16.625 4.77593 16.4556 4.54749 16.1874 4.43574L11.875 2.63892M11.875 11.2153V2.63892M11.875 2.63892L7.125 4.61808",
    stroke: "#D22268",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/Map Icon.8cd998e21d951f0168bb0a6a0b4b742c.svg";
export { ForwardRef as ReactComponent };